module.exports = __webpack_public_path__ + "static/media/text-in.30ff19ee.svg";